module.exports = __webpack_public_path__ + "img/home_ai.816a9ccc.png";